export enum ResetPasswordStepsEnum {
    STEP1 = "STEP1",
    STEP2 = "STEP2",
    STEP3 = "STEP3",
}
